type Props = {
  source: any
  onSubmit: (sourceUpdated: any) => void
}

export const StepOne: React.FC<Props> = ({ source, onSubmit }) => {
  return <>TODO</>
  // const FormInstance = FormClient.useForModel({
  //   modelName: 'IndexerSource',
  //   keysToMerge: ['configuration'],
  //   onSuccess: onSubmit,
  // })

  // useEffect(() => {
  //   FormInstance.start({ where: { id: source.id } })
  // }, [])

  // return (
  //   <Flex vertical className="w-full">
  //     <FormInstance.FormView
  //       isModal={false}
  //       propsForm={{ buttonLabel: 'Next' }}
  //     >
  //       <Form.Item
  //         label="Bot Token"
  //         name="configuration.botToken"
  //         rules={[{ required: true, message: 'Bot token is required' }]}
  //       >
  //         <Input placeholder="Your bot token" />
  //       </Form.Item>
  //     </FormInstance.FormView>
  //   </Flex>
  // )
}
